import { ContractList } from "@container/contract-list";
import { useNavigate } from "react-router-dom";
import AuthLayout from "@container/layout/auth";

export default function JobSeekerContract() {
    const navigate = useNavigate()

    return (
        <AuthLayout>
            <ContractList
                onGoToJobMatch={() => navigate("/dashboard")}
            />
        </AuthLayout>
    );
}
